export default __webpack_public_path__ + "static/RKLogo-59024d4d9498ddc768baf7ea29a5e70e.png";